import React, { useState, useEffect } from 'react';
import Advertisement from './Advertisement';
import { useLocation } from 'react-router-dom';

interface AdContainerProps {
  location: 'masthead' | 'sidebar-left' | 'sidebar-right';
  className?: string;
}

// This would normally come from an API or context
const getAdsForLocation = (location: string, currentPage: string): boolean => {
  // Mock data - in a real app, this would be fetched from an API
  const allAds = [
    {
      location: 'masthead',
      pages: ['ihtiyac-kredisi', 'konut-kredisi', 'tasit-kredisi']
    },
    {
      location: 'sidebar-right',
      pages: ['mevduat']
    },
    {
      location: 'sidebar-left',
      pages: ['kredi-kartlari']
    }
  ];

  // Check if there are ads for this location and page
  return allAds.some(ad => 
    ad.location === location && 
    ad.pages.includes(currentPage)
  );
};

const AdContainer: React.FC<AdContainerProps> = ({ location, className = '' }) => {
  const [hasAds, setHasAds] = useState(false);
  const { pathname } = useLocation();
  
  // Get current page from pathname
  const currentPage = pathname === '/' ? 'home' : pathname.substring(1);

  useEffect(() => {
    // Check if there are ads for this location and page
    const adsAvailable = getAdsForLocation(location, currentPage);
    setHasAds(adsAvailable);
  }, [location, currentPage]);

  // If there are no ads for this location and page, don't render anything
  if (!hasAds) return null;
  
  let containerClass = '';
  
  switch (location) {
    case 'masthead':
      containerClass = 'w-full h-[200px] mb-6';
      break;
    case 'sidebar-left':
    case 'sidebar-right':
      containerClass = 'w-[300px] h-[600px] hidden lg:block sticky top-24';
      break;
  }
  
  return (
    <div className={`ad-container ${containerClass} ${className}`}>
      <Advertisement location={location} />
    </div>
  );
};

export default AdContainer;